export const validateFileSize = (size: number, maxSize = 5) => {
  const currentSize = size / 1024 / 1024 // byte to mb

  return currentSize <= maxSize
}
